import PassportService from './passportService'

export default function usePassport(axiosIns) {
  const passport = new PassportService(axiosIns)

  return {
    passport,
  }
}
